import { Extension } from '@tiptap/core';

const LineHeight = Extension.create({
  name: 'lineHeight',

  addGlobalAttributes() {
    return [
      {
        types: ['paragraph', 'heading', 'listItem'],
        attributes: {
          lineHeight: {
            default: null,
            renderHTML: attributes => {
              if (!attributes.lineHeight) return {};
              return { style: `line-height: ${attributes.lineHeight}` };
            },
            parseHTML: element => element.style.lineHeight || null,
          },
          itemSpacing: {
            default: null,
            renderHTML: attributes => {
              if (!attributes.itemSpacing) return {};
              return { style: `margin-bottom: ${attributes.itemSpacing}` };
            },
            parseHTML: element => element.style.marginBottom || null,
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setLineHeight:
        value =>
        ({ commands }) =>
          commands.updateAttributes('paragraph', { lineHeight: value }) &&
          commands.updateAttributes('heading', { lineHeight: value }) &&
          commands.updateAttributes('listItem', { lineHeight: value }),

      unsetLineHeight:
        () =>
        ({ commands }) =>
          commands.updateAttributes('paragraph', { lineHeight: null }) &&
          commands.updateAttributes('heading', { lineHeight: null }) &&
          commands.updateAttributes('listItem', { lineHeight: null }),

      setItemSpacing:
        value =>
        ({ commands }) =>
          commands.updateAttributes('listItem', { itemSpacing: value }),

      unsetItemSpacing:
        () =>
        ({ commands }) =>
          commands.updateAttributes('listItem', { itemSpacing: null }),
    };
  },
});

export default LineHeight;

